import React from "react";
import { graphql } from "gatsby";
import { FullWidthImage as FullwidthImageComponent } from "@zempler/theme/src/components/fullWidthImage/FullWidthImage";
import { NestedComponentRenderer } from "../../NestedComponentRenderer";

export const FullWidthImage = ({ data, ...rest }) => {
  const nestedComponents = data.componentPicker.map((item) => {
    const { component } = item;

    return {
      ...component,
      areas: undefined,
    };
  });

  return (
    <FullwidthImageComponent {...data} image={data.largeImage ? data?.largeImage.image?.localFile : data?.image?.image?.localFile} mobileImage={data?.mobileImage?.image?.localFile}>
      <NestedComponentRenderer components={nestedComponents} />
    </FullwidthImageComponent>
  );
};

export const FullWidthImageQuery = graphql`
  fragment FullWidthImage on UMBRACO_FullWidthImageComponentType {
    heading
    subHeading: subheading
    backgroundColor: backgroundColour
    bannerOnRight
    image {
      image {
        ...FullImage
      }
    }
    largeImage {
      image {
        ...FullImageLarge
      }
    }
    mobileImage {
      image {
        ...FullImageSmall
      }
    }
    componentPicker {
      remoteTypeName
      component {
        __typename
        ...NestedComponents
      }
      areas {
        blockGridItems {
          component {
            __typename
            ...NestedComponents
          }
        }
      }
    }
    link {
      ...Link
    }
  }
`;
